module.exports = __webpack_public_path__ + "img/orders-pagination-back.233e9133.svg";